import { translate } from "@/hooks/useLanguage";
import { LanguageKey } from "@/types/generated/LanguageKey";

const AiDisclaimer = () => {

  return (
    <div className="alert alert-light border-0 bg-light">
      <small className="text-muted">
        <strong>{translate(LanguageKey.ai_disclaimer_key)}</strong>
      </small>
    </div>
  );
};

export default AiDisclaimer;
